import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// For solutions pages
export interface SolutionPageContentType{
    contentHeading:String,
    introduction:String,
    body:{topic:String,content:String}[]
}

export interface CommentsAboutStockInvent{
    comment:String
    image:String
    position:String
}



export interface SolutionPageContentPattern{
    heading:String
    introduction:String
    image:{caption:String,src:String}[]
    description:String
    common:{introduction:{effective:String, content:String},closing:String}
    content:SolutionPageContentType[] 
    idealFor:String 
}


// For service pages
// export interface PageContentType

export interface PageContentPattern{
    heading:String
    introduction:String
    description:String
    common:{introduction:{effective:String, content:String},closing:String}
    content:{
        contentHeading:String,
        introduction:String,
        contentType:String
        body:{topic:String,content:String}[]
    }[]  
}

// Define types for the tracking data
export interface TrackingUpdate {
    date: string;
    status: string;
}

export interface TrackingData {
    id: string;
    name: string;
    status: string;
    confirmedOn: string;
    received: boolean;
    updates: TrackingUpdate[];
}

interface AppState{
    subMenu :String
    page : String;
    pos : number;
    currentMenu : String
    drawer : String
    drawerDropNav : String
    dashboardFit : Boolean
    theme : String
    modal : String
    infoType : String
    overviewModalData : {overviewType:String, overViewOn:String, item:String, timeframe:String}
    openItem : number
    cookie : String
    chatView : Boolean
    defaultPaymentMethod : String
    token: String,
    waitlist:String,
    waitListResponse:String
    chatMessages: { text: string; from: Boolean }[]

    
}


const initialState : AppState = {
    subMenu : "",
    page : "Home",
    pos : 0,
    currentMenu: "home",
    drawer : "",
    drawerDropNav : "",
    dashboardFit : true,
    theme : "light",
    modal : "",
    infoType : "privacy",
    overviewModalData : {overviewType:"",overViewOn:"",item:"",timeframe:""},
    openItem: 0,
    cookie: localStorage.getItem("stockinvent_cookie") || "",
    chatView : false,
    defaultPaymentMethod : "Card",
    token: "",
    waitlist:"",
    waitListResponse:"",
    chatMessages: []
    
}

const AppSlice = createSlice({
    name:"app",
    initialState,
    reducers:{
        // Sets your current page
        setPage: (state , action:PayloadAction<string>) => { 
            state.page = action.payload
        },
        // Set Vertical position globally
        setPos: (state, action:PayloadAction<number>) =>{
            state.pos = action.payload
        },

        // Set Vertical position globally
        setMenu: (state, action:PayloadAction<String>) =>{
            state.currentMenu = action.payload
        },

        setDrawer: (state, action:PayloadAction<String>) => {

            state.drawer = action.payload

        },

        setDrawerDropNav: (state, action:PayloadAction<String>) => {

            state.drawerDropNav = action.payload

        },

        setDashboardFit: (state, action:PayloadAction<Boolean>) => {

            state.dashboardFit = action.payload

        },
        setTheme: (state, action:PayloadAction<String>) => {

            state.theme = action.payload
            
        },
        setModal: (state, action:PayloadAction<String>) => {

            state.modal = action.payload

        },
        setOverviewTile: (state, action:PayloadAction<{overviewType:String, overViewOn:String, item:String, timeframe:String}>) =>{
            state.overviewModalData = action.payload
        },
        setSubMenu : (state, action:PayloadAction<String>) => {
            state.subMenu = action.payload
        },

        setInfoType : (state, action:PayloadAction<String>) => {
            state.infoType = action.payload
        },
        setOpenItem : (state, action:PayloadAction<number>) => {
            state.openItem = action.payload
        },

        setCookie : (state, action:PayloadAction<String>) => {
            localStorage.setItem("stockinvent_cookie", action.payload.toString())
            state.cookie = action.payload
        },
        
        setChatView : (state, action:PayloadAction<Boolean>) => {
            state.chatView = action.payload
        },
        setDefaultPaymentMethod : (state, action:PayloadAction<String>) => {
            state.defaultPaymentMethod = action.payload
        },
        setWaitListResponse:  (state, action:PayloadAction<String>) => {
            state.waitlist = action.payload
        },
        setWaitListResponseMessage: (state, action:PayloadAction<String>) => {
            state.waitListResponse = action.payload
        },
        setChatMessages: (state, action:PayloadAction<{ text: string; from: Boolean }>) => {
            state.chatMessages.push(action.payload)
        }

    }
}
);

export const {setChatMessages,setWaitListResponseMessage,setDefaultPaymentMethod,setChatView,setCookie,setSubMenu, setPage, setPos, setMenu, setDrawer, setDrawerDropNav, setDashboardFit, setTheme, setModal,setOverviewTile, setInfoType, setOpenItem, setWaitListResponse} = AppSlice.actions;
export default AppSlice;